import { useState, useEffect } from "react";
import { getProductsController } from "../../../../node_modules/shops-query/src/modules/products/index.js";
import { shopid, getUserData } from "../../../utils/url";
import recommendedForYouImage from "../../../assets/recommendedForYouImage.png";
import { useToast } from "../../toast";
import { useContext } from "react";
import LoginModalContext from "../../../contexts/LoginModalContext";
import { Link } from "react-router-dom";
import ProductCard from "../../productCard";

const RecommendedSection = () => {
  const [products, setProducts] = useState([]);
  /* isWishlisted and wishlist state removed as they are handled inside ProductCard */
  const { showToast, ToastContainer } = useToast();
  const { openLogin } = useContext(LoginModalContext);
  
  const userInfo = getUserData();
  const userId = userInfo?.u_id;

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await getProductsController(shopid, null);
        if (res?.data?.products) {
          setProducts(res.data.products);
        } else if (Array.isArray(res)) {
          setProducts(res);
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.error("An error occurred:", error);
        if (error?.response?.data?.data?.products) {
          setProducts(error.response.data.data.products);
        }
      }
    };

    fetchProducts();
  }, []);



  return (
    <div className="w-full md:max-w-[95.5%] bg-white p-4 sm:mt-[80.7px] font-poppins">
      {/* MOBILE Recommended Card*/}
      <div className="block lg:hidden mb-6 -mr-4">
        <div className="w-full">
          <img
            src={recommendedForYouImage}
            alt="Recommended"
            className="w-full h-[346.7px] object-cover"
          />
          <div className="bg-black text-white text-center w-full h-[80px] flex flex-col items-center justify-center">
            <p className="text-xl tracking-wide">RECOMMENDED FOR YOU</p>
            <Link to="/all-products">
              <button className="mt-1 font-semibold text-[12px] leading-[100%] tracking-[0px] uppercase underline">
                VIEW ALL
              </button>
            </Link>
          </div>
        </div>
      </div>

      {/* DESKTOP Layout */}
      <div className="w-full flex lg:flex-row flex-col gap-6">
        {/* DESKTOP Left Card */}
        <div className="hidden lg:block min-w-[480px] ml-[3.1%]">
          <img
            src={recommendedForYouImage}
            alt="Recommended"
            className="w-[480px] h-[450px] object-cover"
          />

          <div className="bg-black text-white text-center w-[480px] h-[120px] flex flex-col items-center justify-center">
            <p className="font-medium text-[32px] leading-[53px] uppercase">
              RECOMMENDED FOR YOU
            </p>
            <Link to="all-products">
              <button className="mt-1 font-poppins font-semibold text-[18px] leading-[100%] tracking-[0px] uppercase underline">
                VIEW ALL
              </button>
            </Link>
          </div>
        </div>

        {/* PRODUCTS SCROLL AREA */}
        <div className="flex-1 overflow-x-auto black-scrollbar flex md:gap-6 gap-4 pb-4 cursor-pointer">
          {products.map((product) => {
            return (
              <div key={product.id} className="md:min-w-[303px] min-w-[203px] pb-4">
                 <ProductCard item={product} showHeart={true} isThisWishlistPage={false} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RecommendedSection;